<template>
  <div class="detail">
    <div class="container-auto wrapper">
      <div class="breadcrumbs">首页-融资需求-需求填报</div>
      <div class="detail-content">
<!--        <div class="apply-box">-->
<!--          <div class="apply-item" :class="{active: active === 1}">-->
<!--            <img src="@/assets/img/demand/icon-1-active.png" alt="" v-if="active === 1">-->
<!--            <img src="@/assets/img/demand/icon-1.png" alt="" v-if="active !== 1">-->
<!--            <div class="name">填写需求</div>-->
<!--          </div>-->
<!--          <div class="line"></div>-->
<!--          <div class="apply-item">-->
<!--            <img src="@/assets/img/demand/icon-2.png" alt="">-->
<!--            <div class="name">提交申请</div>-->
<!--          </div>-->
<!--          <div class="line"></div>-->
<!--          <div class="apply-item">-->
<!--            <img src="@/assets/img/demand/icon-3.png" alt="">-->
<!--            <div class="name">融资服务对接</div>-->
<!--          </div>-->
<!--        </div>-->

        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="140px" class="ruleForm">
          <el-form-item label="企业名称" prop="enterName" required>
            <el-input v-model="ruleForm.enterName" clearable></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="name" required>
            <el-input v-model="ruleForm.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="phone" required>
            <el-input v-model="ruleForm.phone" clearable></el-input>
          </el-form-item>
          <el-form-item label="所属区县" prop="areaCode" required>
            <el-select v-model="ruleForm.areaCode" filterable placeholder="请选择" class="full-width">
              <el-option
                v-for="item in regionList"
                :key="item.value"
                :label="item.text"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资金用途" prop="fundsUse" required>
            <el-input v-model="ruleForm.fundsUse" clearable></el-input>
          </el-form-item>
          <el-form-item label="融资金额(万元)" prop="amount" required>
            <el-input v-model="ruleForm.amount" clearable></el-input>
          </el-form-item>
          <el-form-item label="融资期限(月)" prop="terms" required>
            <el-input v-model="ruleForm.terms" clearable></el-input>
          </el-form-item>
          <el-form-item label="意向机构1" prop="organIdOne" required>
            <el-select v-model="ruleForm.organIdOne" filterable placeholder="请选择" class="full-width">
              <el-option
                v-for="item in organList"
                :key="item.organName"
                :label="item.organName"
                :value="item.organName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="意向机构2" class="v-align">
            <el-select v-model="ruleForm.organIdTwo" filterable placeholder="请选择" class="full-width">
              <el-option
                v-for="item in organList"
                :key="item.organName"
                :label="item.organName"
                :value="item.organName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="意向机构3" class="v-align">
            <el-select v-model="ruleForm.organIdThree" filterable placeholder="请选择" class="full-width">
              <el-option
                v-for="item in organList"
                :key="item.organName"
                :label="item.organName"
                :value="item.organName">
              </el-option>
            </el-select>
          </el-form-item>

          <div class="aggrement">
            <el-checkbox v-model="checked" class="check-box"></el-checkbox>
            我已阅读并同意 <span @click="dialogTableVisible = true">《授权协议》</span>
          </div>
          <div class="btn-group">
            <el-button type="info" class="btn" @click="$router.back()">取消</el-button>
            <el-button type="primary" class="btn" @click="submitForm('ruleForm')">提交</el-button>
          </div>
        </el-form>
      </div>
      <el-dialog title="授权协议" :visible.sync="dialogTableVisible">
        <Agreement class="wrapper-content" type="1"></Agreement>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {getBankList, queryDictAll, saveNeedJrb} from "@/api";
import Agreement from "./agreement";
export default {
  components: {
    Agreement
  },
  data() {
    return {
      loading: false,
      dialogTableVisible: false,
      active: 1,
      ruleForm: {
        id: "",
        enterName: "",
        areaCode: "",
        fundsUse: "设备更新",
        amount: "",
        terms: "",
        organIdOne: "",
        organIdTwo: "",
        organIdThree: "",
        name: "",
        phone: ""
      },
      checked: false,
      rules: {
        enterName: [
          {required: true, message: "请输入企业名称", trigger: "blur"},
        ],
        areaCode: [
          {required: true, message: "请选择所属区县", trigger: "change"},
        ],
        fundsUse: [
          {required: true, message: "请选择资金用途", trigger: "change"},
        ],
        amount: [
          {required: true, message: "请输入融资金额", trigger: "blur"},
        ],
        terms: [
          {required: true, message: "请输入融资期限", trigger: "blur"},
        ],
        organIdOne: [
          {required: true, message: "请选择意向机构1", trigger: "change"},
        ],
        name: [
          {required: true, message: "请输入联系人", trigger: "blur"},
        ],
        phone: [
          {required: true, message: "请输入联系方式", trigger: "blur"},
        ],
      },
      bankList: [],
      xuqiuList: [],
      regionList: [],
      fundsUseList: [
        {
          value: "设备更新",
          text: "设备更新"
        }
      ],
      organList:[
        {organName: "永赢金租"},
        {organName: "华融金租宁波分公司"},
        {organName: "浙港融资租赁"},
        {organName: "通商融资租赁"},
        {organName: "智慧普华租赁"},
        {organName: "金通融资租赁"},
        {organName: "东海融资租赁"},
        {organName: "中金融资租赁"},
        {organName: "晟融融资租赁"},
        {organName: "多盛融资租赁"},
        {organName: "华道融资租赁"},
        {organName: "盈峰融资租赁"},
        {organName: "天信融资租赁"},
        {organName: "虎堂融资租赁"},
        {organName: "三易融资租赁"},
        {organName: "途众融资租赁"},
        {organName: "金铂仕融资租赁"},
        {organName: "新大洲融资租赁"},
        {organName: "汇融融资租赁"},
        {organName: "星程融资租赁"},
        {organName: "香溢融资租赁"},
        {organName: "国骅融资租赁"},
        {organName: "富博融资租赁"},
        {organName: "蚕豆融资租赁"},
        {organName: "兴合融资租赁"},
      ]
    };
  },
  methods: {
    async getBankList() {
      let res = {};
      res = await getBankList({});
      if (res.code === "00000") {
        this.bankList = res.result;
        this.organList.push(...this.bankList)
      }
    },
    // 查询码表
    queryDictCode(parentCode) {
      queryDictAll({parentCode: parentCode}).then(res => {
        const data = res.result?.data || [];
        let arr = [];
        for (let i = 0; i < data.length; i++) {
          arr.push({
            text: data[i].name,
            value: data[i].code
          })
        }
        switch (parentCode) {
          case "XQTB_XQLX":
            this.xuqiuList = arr
            return;
          case "pykqx":
            this.regionList = arr
            return;
          case "XQTB_ZZYT":
            this.fundsUseList = arr
        }
      })
    },
    submitForm(formName) {
      if (!this.checked) {
        this.tips("请勾选用户协议", "warning")
        return
      }
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          saveNeedJrb(_this.ruleForm).then(res => {
            if (res.code === "00000") {
              _this.tips("操作成功")
              _this.resetParam(formName)
            } else {
              _this.tips("操作失败", "error")
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetParam(formName) {
      this.ruleForm = {
        id: "",
        enterName: "",
        areaCode: "",
        fundsUse: "",
        amount: "",
        terms: "",
        organIdOne: "",
        organIdTwo: "",
        name: "",
        phone: ""
      }
      this.$refs[formName].resetFields();
      this.$nextTick(() => {
        this.$refs[formName].clearValidate();
      });
    },
    tips(val, type) {
      this.$notify({
        title: "提示",
        message: val,
        dangerouslyUseHTMLString: true, // 使用html片段
        type: type || "success"
      });
    },
    load() {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    closeLoad() {
      this.loading.close();
    },
  },
  mounted() {
    this.getBankList()
    this.queryDictCode("XQTB_XQLX")
    this.queryDictCode("pykqx")
    // this.queryDictCode("XQTB_ZZYT")
  },
};

</script>

<style scoped lang="scss">
.detail {
  min-height: 100vh;
  background: #F3F3F8 url("~@/assets/img/policy/bg.png") no-repeat center top;
  background-size: 100% auto;
  padding-bottom: 50px;
  padding-top: 20px;

  .breadcrumbs {
    font-size: 16px;
    line-height: 19px;
    color: #333333;
    padding: 20px 0;
  }

  .detail-content {
    width: 100%;
    border-radius: 3px;
    background: #FFFFFF;
    box-shadow: 0px 3px 7px 0px rgba(188, 188, 188, 0.5);
    display: flex;
    flex-direction: column;
    padding: 40px;


    .apply-box {
      width: 100%;
      height: 229px;
      background: #EBF3FF;
      display: flex;
      align-items: center;
      justify-content: center;

      .line {
        width: 270px;
        height: 1px;
        border-top: 1px solid #B5C7FF;
        margin-top: -48px;
      }

      .apply-item {
        width: 132px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .name {
          font-size: 16px;
          font-weight: normal;
          line-height: 40px;
          color: #333333;
          margin-top: 8px;
        }

        &.active {
          .name {
            font-weight: bolder;
          }
        }
      }
    }

    .ruleForm {
      padding: 30px 160px 0;

      .aggrement {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: normal;
        line-height: 22px;
        color: #333333;
        margin-top: 30px;

        .check-box {
          margin-right: 8px;
        }

        span {
          color: #1D52D9;
        }
      }

      .btn-group {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 38px;

        .btn {
          width: 120px;
        }

        .el-button--primary {
          background: #1D52D9;
          border-color: #1D52D9;
        }

        .el-button--info:focus, .el-button--info:hover {
          background: #1447c9;
          border-color: #1447c9;
        }

        .el-button--info {
          background: #CCCCCC;
          border-color: #CCCCCC;
        }

        .el-button--info:focus, .el-button--info:hover {
          background: #bebdbd;
          border-color: #bebdbd;
        }
      }
    }

    .wrapper-content {
      flex: 1;
      overflow-y: scroll;

      div {
        margin-bottom: 4px;
      }
    }

    .v-align{
      ::v-deep {
        .el-form-item__label:before {
          content: '*';
          color: #F56C6C;
          margin-right: 4px;
          visibility: hidden;
        }
      }
    }
  }
}
</style>
